<template>
  <v-container class="max-width-1200">

    <v-row class="text-justify justify-center">
      <v-col>

        <v-row class="justify-center">
          <v-col class="align-center d-flex">
            <v-img
              src="@/assets/em/im_mockup_01.png"
              max-width="500"
              contain
              class="ml-12 mr-auto"
              style="width: calc(100% - 48px);">
            </v-img>
          </v-col>
          <v-col>
            <v-row>
              <v-col class="pb-0 headline text-uppercase">
                {{ $t('invoiceMonitor.software.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('invoiceMonitor.software.subtitle') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('invoiceMonitor.software.text.01' )}}<br>
                {{ $t('invoiceMonitor.software.text.02' )}}
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

    <v-row>
      <v-col>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'Software',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
